// extracted by mini-css-extract-plugin
export default {"wrapper":"add-customer_wrapper__c0RPs"};